import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import "./Parallax.scss";

function Parallax({ kicker, title, description, tags = [] }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });

  const titleY = useTransform(scrollYProgress, [0, 1], ["18%", "-22%"]);
  const railX = useTransform(scrollYProgress, [0, 1], ["-18%", "18%"]);
  const gridY = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);
  const tagY = useTransform(scrollYProgress, [0, 1], ["18%", "-18%"]);

  return (
    <div className="parallax" ref={ref}>
      <motion.div className="parallax__grid" style={{ y: gridY }} />
      <motion.div className="parallax__rail parallax__rail--top" style={{ x: railX }} />
      <motion.div className="parallax__rail parallax__rail--bottom" style={{ x: railX }} />

      <div className="parallax__inner section-shell">
        <motion.div className="parallax__copy" style={{ y: titleY }}>
          <span>{kicker}</span>
          <h2>{title}</h2>
          <p>{description}</p>
        </motion.div>

        {tags.length > 0 && (
          <motion.div className="parallax__tags" style={{ y: tagY }} aria-label={`${title} highlights`}>
            {tags.map((tag, index) => (
              <span className={`parallax__tag parallax__tag--${index + 1}`} key={tag}>
                {tag}
              </span>
            ))}
          </motion.div>
        )}
      </div>
    </div>
  );
}

export default Parallax;
